<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
                <div class="mb-2 d-flex justify-content-md-start">
                  <div class="form-group">
                  <label>Date From</label>
                  <input v-model="datefrom" type="date" class="form-control" />
                  </div>
                  <div class="form-group ms-2">
                  <label>Date To</label>
                  <input v-model="dateto" type="date" class="form-control" />
                  </div>
                  <span><br><b-button @click="FilterData" class="mt-2 mx-2" variant="primary"><i class="mdi mdi-filter"></i> Filter</b-button></span>
                  <div><br><export-excel class="btn btn-info mt-2 mb-2" :data=reportpaymentsbyuser name="PAYMENTSPERUSER.xls"> Export <i class="mdi mdi-download"></i></export-excel></div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(payment)="data">
                  {{ commas(data.item.payment) }}
                </template>
                <template #cell(pharmacy)="data">
                  {{ commas(data.item.pharmacy) }}
                </template>
                </b-table>
                <div class="total-payments">
                  <strong>Total Services:</strong> {{ commas(totalServices) }}
                  <span class="horizontal-separator">  </span>
                  <strong>Total Pharmacy:</strong> {{ commas(totalPharmacy) }}
                </div>

              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
  // import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { reportpaymentsbyuserMethods, reportpaymentsbyuserComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Payments Per User Report",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Payments Per User Report",
        items: [ {text: "Dashboard",to: "/",}, {text: "Payments Per User Report",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'user', label: 'User Name', visible: true },
            { key: 'contact', label: 'Contact', visible: true },
            { key: 'payment', label: 'Services', visible: true },
            { key: 'pharmacy', label: 'Pharmacy', visible: true },
          ],
        datefrom: new Date().toLocaleDateString('fr-CA'),
        dateto: new Date().toLocaleDateString('fr-CA'),
      };
    },
    computed: {
      ...reportpaymentsbyuserComputed,
      List() { return this.reportpaymentsbyuser.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.reportpaymentsbyuser.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.reportpaymentsbyuser.length>0) { a=false;} else { a=true;} return a },
      totalServices() { return this.reportpaymentsbyuser.reduce((total, item) => total + Number(item.payment), 0); },
      totalPharmacy() { return this.reportpaymentsbyuser.reduce((total, item) => total + Number(item.pharmacy), 0); },
    },
    mounted() {
      this.fetchReportPaymentsbyUser();
      this.TotalRows = this.reportpaymentsbyuser.length;
      this.isBusy=false;
    },
    methods: {
      ...reportpaymentsbyuserMethods,
        Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      FilterData() {
        this.filterReportPaymentsbyUser({datefrom:this.datefrom,dateto:this.dateto});
      },
      commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    },
  };
  </script>
  <style scoped>
  .horizontal-separator {
    margin: 0 20px; 
  }
</style>